import { myShortlistBoardApi } from '../../../api/shortlist-board/shortlistBoard.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { myMetastructureMappingService } from '../../internal/MetastructureMappingService/MetastructureMappingService.connected';
import { myTagsService } from '../TagsService/TagsService.connected';
import { createShortlistBoardMutationService } from './ShortlistBoardMutationService.impl';

export const myShortlistBoardMutationService =
  createShortlistBoardMutationService({
    api: myShortlistBoardApi,
    services: {
      errorService: myErrorService,
      messageService: myMessageService,
      tagsService: myTagsService,
      metastructureMappingService: myMetastructureMappingService
    }
  });
